import * as React from "react";
import {logger} from '../../utils';

export default function DataPivot(data) {

    const Pivot = async (values) => {
    //    logger("Look AT ME")
     //   logger('Pivot In',values)
        var obj = {}
        Object.keys(values[0]).map((row) => {
            if (!(row in obj) && row != 'Data' && row != 'ColumnName') {
                obj[row] = '';
            }
        });
        values.map((row) => {
            if (!(row.ColumnName in obj) && row.ColumnName != null) {
                obj[row.ColumnName] = '';
            }
        });
       // logger(obj)
        var output = []
        var tep = {}
        values.forEach(e => {
            if (output.find(element => element.ID == e.ID) === undefined) {
                Object.keys(obj).forEach(m => {
                    tep[m] = e[m]
                    if (e.ColumnName != null) {
                        tep[e.ColumnName] = e.Data
                    }
                })
                output.push(tep)
                tep = {}
            } else {
                output[output.findIndex((element) => element.ID == e.ID)][e.ColumnName] = e.Data
             //   logger(e.ColumnName + ': ' + e.Data)
            }
        })

  //     logger('leaving pivot')
  //      logger('PivotOut', output)
        return (output);
    }

 
    return (Pivot(data));
}